import CustomConfirmationDialog from '../../../../Dispatch/RouteExecution/DriverPopUp/common/CustomConfirmationDialog';
import { postData } from '../../../../../../api/componentAPIs';

export default ({
  selectedReceiverData,
  onCancel,
  enqueueSnackbar,
  terminalCode
}) => {
  const deleteReceiver = () => {   
    if (!selectedReceiverData) {
      return;
    }
    const requestParams = {
      receiverId: selectedReceiverData.receiverId,
      terminalCode: terminalCode
    };
    postData('DeleteCustomerReceiver', requestParams)
      .then((response) => {
        if (response && Math.trunc(response.status / 100) === 2) {
          enqueueSnackbar(`Deleted receiver '${selectedReceiverData.receiverName}'`, {
            variant: 'success',
            style: { wordBreak: 'break-word' }
          });
          onCancel(selectedReceiverData.receiverId);
        } else {
          handleError(response);
        }
      })
      .catch(() => {
        handleError({});
      });
  };

  const handleError = (response) => {
    const errorMessage = response?.response?.data?.error?.message || response?.message; 
    if (statusCode !== 403) {
      enqueueSnackbar(errorMessage || `Error deleting receiver '${selectedReceiverData.receiverName}'`, {
        variant: 'error',
        style: { wordBreak: 'break-word' }
      });
    }
    onCancel();
  };

  return (
    <>
      {selectedReceiverData && (
        <CustomConfirmationDialog
          title="Delete Receiver"
          cancelButtonLabel="Cancel"
          confirmButtonLabel="Remove"
          mode="danger"
          onConfirm={deleteReceiver}
          onCancel={onCancel}>
          {`Are you sure you want to delete selected receiver "${selectedReceiverData.receiverName}" from receiverList?`}
        </CustomConfirmationDialog>
      )}
    </>
  );
};
